import React, { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import { usePageLayout } from '../hooks/usePageLayout'
import { useJWTPayload } from '../hooks/useToken'

function WorldBuilder() {
  const layoutOptions = useMemo(
    () => ({
      showSidebar: true,
      showHeader: false,
      showFooter: false,
      title: {
        en: '3D World Builder',
        zh_cn: '3D世界构建器',
        zh_hk: '3D世界構建器',
      },
    }),
    [],
  )

  usePageLayout(layoutOptions)

  const [searchParams] = useSearchParams()
  const payload = useJWTPayload()

  let roomId = searchParams.get('id')
  if (!roomId) {
    if (payload && payload.id) {
      roomId = `user_${payload.id}`
    } else {
      roomId = 'guest'
    }
  }

  // const iframeUrl = `http://localhost:8250?id=${roomId}&iframe=true`
  const iframeUrl = `https://3d.feelingss.io?id=${roomId}&iframe=true`

  return (
    <div style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
      <iframe
        src={iframeUrl}
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
        }}
        title="3D World Builder"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; pointer-lock"
        allowFullScreen
      />
    </div>
  )
}

export default WorldBuilder
